// Naive-local datetime helpers for the scheduling fields (migration 007).
// Convention: `YYYY-MM-DDTHH:mm:ss` strings WITHOUT a timezone suffix,
// stored verbatim by PocketBase and parsed with `new Date(str)` (local per
// JS spec). No UTC conversions anywhere in this path.

// "2026-08-20T09:00:00" → "2026-08-20T09:00" (datetime-local input value)
export function toLocalInput(value) {
  if (!value) return '';
  return String(value).slice(0, 16);
}

// "2026-08-20T09:00" → "2026-08-20T09:00:00" (schema shape)
export function fromLocalInput(value) {
  if (!value) return '';
  return String(value).length === 16 ? `${value}:00` : String(value);
}

// Default working-hours window for a given day ("YYYY-MM-DD").
export function defaultWindow(day) {
  if (!day) return { start: '', end: '' };
  return { start: `${day}T09:00:00`, end: `${day}T17:00:00` };
}
